import { render, staticRenderFns } from "./Ueberleitung.vue?vue&type=template&id=4d31dc3e&scoped=true"
import script from "./Ueberleitung.vue?vue&type=script&lang=ts"
export * from "./Ueberleitung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d31dc3e",
  null
  
)

export default component.exports